import { Button, Toolbar, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_BOOKING_ADDITIONAL_QUESTIONS, STEP_PAYMENT, STEP_SCHEDULE } from 'pages/CustomerBookingCreate/constants';
import { stepState } from 'pages/CustomerBookingCreate/state';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';

const useStyles = makeStyles(theme => ({
}));
const BookingAdditionalQuestionsScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const history = useHistory()
  return (
    <>
      <PageHeader
        backStep={STEP_SCHEDULE}
        currentStep={STEP_BOOKING_ADDITIONAL_QUESTIONS}
        title={"Book your appointment"}
        subheader={"No charges until you finished your appointment."}
        isCartEnabled={false}
      >
        <Toolbar>
          <div style={{ flexGrow: 1 }} />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setStep(STEP_PAYMENT)
              history.replace(STEP_PAYMENT, { internal: true })
            }}
          >Continue</Button>

        </Toolbar>
      </PageHeader>
    </>
  )
}

export { BookingAdditionalQuestionsScreen }